import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { getInstance } from '../../../../services/instance';
import { shouldReportErrorMonitor } from '../../Challenge/helpers/shouldReportErrorMonitor';
import { handleError } from '../../../ErrorHandler/errorHandlerPropsMap';

export interface PersonaSettings {
  welcomeMessage?: string;
  placeholder?: string;
  enableWelcomeMessage?: boolean;
  enablePlaceholder?: boolean;
  legalMessage?: string;
  enableLegalMessage?: boolean;
  voiceModeEnabled?: boolean;
  systemVoiceId?: string;
  configurationId?: string;
}

export interface PersonaSettingsItem {
  personaId: string;
  settings: PersonaSettings;
}

export default async function (
  flowAPI: ControllerFlowAPI,
  personaId: string,
): Promise<PersonaSettings | null> {
  const instanceFromUrl = getInstance(flowAPI);

  const { withErrorHandler } = flowAPI.errorHandler;

  try {
    const getPersonaSettingsTransaction = flowAPI.panoramaClient.transaction(
      'get-persona-settings',
    );

    getPersonaSettingsTransaction.start();

    const response = await withErrorHandler(
      async () => {
        return flowAPI.httpClient.get<PersonaSettingsItem>(
          `/_api/online-programs-ai-helper-serverless/settings`,
          {
            params: { personaId },
            headers: {
              Authorization: instanceFromUrl,
            },
          },
        );
      },
      {
        errorCodesMap: {
          applicationError: {},
        },
      },
    );

    getPersonaSettingsTransaction.finish();

    const personaSettings = response?.data?.settings || null;

    flowAPI.controllerConfig.setProps({
      personaSettings,
    });
    return personaSettings;
  } catch (error) {
    const resolvedError = flowAPI.errorHandler.getResolvedError(error);

    handleError({
      error,
      resolvedError,
      context: 'GetPersonaSettings',
      preventErrorMonitorReport: !shouldReportErrorMonitor(error),
    });

    return null;
  }
}
